export type GameSpecificConfig = {
    LEGEND_LEVEL_IS_USED: boolean
}
